export const highlightText = (
  text: string,
  highlight: string,
): React.ReactNode => {
  try {
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'))
    return (
      <span>
        {parts.map((part, i) => (
          <span
            key={`part-${i + 1}`}
            className={
              part.toLowerCase() === highlight.toLowerCase()
                ? 'body-medium'
                : 'body-light'
            }
          >
            {part}
          </span>
        ))}
      </span>
    )
  } catch {
    return (
      <span>
        <span className={'body-light'}>{text}</span>
      </span>
    )
  }
}
